import { useScriptTag, createSharedComposable } from '@vueuse/core'

export const useGoogle = createSharedComposable(() => {
  const inited = ref(false)

  useScriptTag('https://accounts.google.com/gsi/client', () => {
    inited.value = true
  })

  /**
   * @description 使用 Google Token Client 启用 Google 登录
   * @param {Object} options
   * @param {Function} [options.onSuccess] - 成功回调
   * @param {Function} [options.onError] - 失败回调
   * @return {Object} - { inited: boolean, trigger: Function }
   * @see https://developers.google.com/identity/oauth2/web/guides/use-token-model?hl=zh-cn
   */
  const requestAccessToken = () => {
    return new Promise((resolve, reject) => {
      const client = window.google?.accounts.oauth2.initTokenClient({
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/userinfo.email',
        callback: async (response) => {
          console.log(response)
          if (response.error) return reject(response.error)

          resolve(response)
        },
        error_callback: (error) => {
          reject(error)
        }
      })
      client.requestAccessToken()
    })
  }

  /**
   * @description 使用 Google One Tap 启用 Google 登录
   * @param {Object} options
   * @param {Function} [options.onSuccess] - 成功回调
   * @param {Function} [options.onError] - 失败回调
   * @return {Object} - { inited: boolean, trigger: Function }
   * @see https://developers.google.com/identity/gsi/web/guides/display-google-one-tap?hl=zh-cn#javascript_1
   */
  const requestOneTap = () => {
    return new Promise((resolve, reject) => {
      window.google.accounts.id.initialize({
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/userinfo.email',
        cancel_on_tap_outside: false,
        callback: async (response) => {
          if (response.error) return reject(response.error)

          resolve(response.credential)
        }
      })
      window.google.accounts.id.prompt()
    })
  }

  const closeOneTap = () => {
    try {
      window.google.accounts.id.cancel()
    } catch (e) {
      console.error(e)
    }
  }

  return { inited: readonly(inited), requestAccessToken, requestOneTap, closeOneTap }
})
